// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Flyout__FlyoutTabList___1g0gU{margin:4px 4px 0}.Flyout__FlyoutTabList___1g0gU,.Flyout__PanelTabList___bGMW5{display:flex;flex-direction:column;justify-content:space-around;list-style:none;padding:0}.Flyout__PanelTabList___bGMW5{margin:0}.Flyout__ComponentWrapper___GOGhz{padding:0}", ""]);
// Exports
exports.locals = {
	"FlyoutTabList": "Flyout__FlyoutTabList___1g0gU",
	"PanelTabList": "Flyout__PanelTabList___bGMW5",
	"ComponentWrapper": "Flyout__ComponentWrapper___GOGhz"
};
module.exports = exports;
